<template>
    <h1>Imagens</h1>
</template>

<script>
</script>